<template>
    <div class="login-wrap">
        <div class="login-form">
            <h2 class="login-tit">手机号登录/注册</h2>
            <login-form
                :form="form"
                :list="list"
                :btns="btns"
                :rules="rules"
                labelWidth="auto"
                ref="login"
            />
            <!-- <div class="checkbox">
                <el-checkbox></el-checkbox>
                <el-link type="info" href="">阅读《用户协议》</el-link>
                <el-link type="info" href="">《个人信息保护政策》</el-link>
            </div> -->
        </div>

        <!-- <login-dialog
            v-model="dialogShow"
            :dialogConfig="dialogConfig"
            @closeDialog="closeDialog"
        >
            <div class="login-fail">
                <h2 class="fail-tit">您可以更换手机号</h2>
                <p class="fail-info">
                    或致电010-58934281 <br />
                    客服人员协助您注册
                </p>
            </div>
        </login-dialog> -->
    </div>
</template>

<script>
import LoginForm from "@/components/form";
import loginDialog from "@/components/dialog";
import EInput from "./components/phoneInput.vue";
import Ecodeinput from "./components/codeInput.vue";
import { Captcha } from '@/store/entity/captcha';

export default {
    name: "LoginPage",
    components: {
        LoginForm,
        loginDialog,
    },
    data() {
        return {
            form: {
                telephone: "",
                code: "",
                cacode:"",
            },
            rules: {
                telephone: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur",
                    },
                    {
                        pattern:
                            /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                        message: "请输入正确手机号",
                    },
                ],
                code: [{ required: true, message: "请输入验证码" }],
            },
            content: '发送短信验证码',
            totalTime: 60,
            canClick: true,
            /* 登录出错 改变dialogShow */
            dialogShow: true,
            dialogConfig: {
                title: "提示",
                width: "80%",
            },
            image_base64: "",
        };
    },
    computed: {
        list() {
            return [
                {
                    prop: "telephone",
                    render: EInput,
                    attrs: {
                        prefixIcon: "city ct-kehu",
                        placeholder: "请输入您的手机号码",
                        label: this.content,
                    },
                    position: {
                        span: 24,
                    },
                    listeners: {
                        getCode: this.getCode,
                    },
                },
                {
                    prop: "cacode",
                    render: Ecodeinput,
                    attrs: {
                        prefixIcon: "city ct-anquan",
                        placeholder: "请输入验证码",
                        label:"QWEASD",
                        image_base64: this.image_base64
                    },
                    position: {
                        span: 24,
                    },
                    listeners: {
                        getCaptcha: this.getCaptcha,
                    },
                },
                {
                    prop: "code",
                    render: "ElInput",
                    attrs: {
                        prefixIcon: "city ct-anquan",
                        placeholder: "请输入短信验证码",
                        
                    },
                    position: {
                        span: 24,
                    },
                },
                
            ];
        },

        btns() {
            return [
                {
                    label: "点击进入",
                    attrs: {
                        style: `
                          width: 100%; 
                          margin-top: 80px;
                          color:
                        `,
                    },
                    listeners: {
                        click: this.handleFormSubmit,
                    },
                },
            ];
        },
    },
    created() {
        // 检查有没有合法登陆信息，如果登陆过，直接跳转登陆成功
        let token = this.$store.getters["auth/token"] || null
        const authorized = token && token.checkValid()
        if(authorized){
            this.$router.replace("/loginSuccess");
        }else{
            this.getCaptcha();
        }
        
    },
    methods: {
        /* 表单提交 */
        handleFormSubmit() {
            const set = this.$refs["login"];
            set.validate((valid) => {
                if (valid) {
                    let login = {
                        phonenumber: this.form.telephone,
                        code :this.form.code
                    }
                    //表单信息提交
                        this.$store.dispatch('auth/sms_login', login).then((success) => {
                            if (success) {
                                this.$router.replace("/loginSuccess");
                            }
                        });
                   
                }
            });
        },

        /* 获取验证码 */
        getCode() {
            
            if (!this.form.cacode) {
                this.$message("请先填写下方验证码")
                return;
                }
            if (!this.canClick) {
                return;
                }
                let data = {};
                data.phone_number = this.form.telephone;

                data.timestamp = this.timestamp;
                data.captcha_hash =this.captcha_hash;
                data.captcha_results = this.form.cacode;
                // console.log(data.phone_number)
                Captcha.sendSMSCode(data).then((res) => {
                    if (res) {
                        this.$message('已发送！');
                        this.canClick = false;
                        this.content = this.totalTime + 's重新发送';
                        let clock = window.setInterval(() => {
                        this.totalTime--;
                        this.content = this.totalTime + 's重新发送';
                        if (this.totalTime < 0) {
                            window.clearInterval(clock);
                            this.content = '重新发送验证码';
                            this.totalTime = 60;
                            this.canClick = true;
                        }
                        }, 1000);
                    }
                });
        },
        getCaptcha() {
            Captcha.getCaptcha().then((res) => {
                this.captcha_hash = res.captcha_hash;
                this.timestamp = res.timestamp;
                this.image_base64 = res.image_base64;
            });
            },

        /* 关闭弹窗 */
        closeDialog(done) {
            done();
        },
    },
};
</script>

<style lang="scss" scoped>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100vh;
    background: -moz-linear-gradient(
        to right bottom,
        var(--bg-linear) 0%,
        var(--main-color) 100%
    );
    background: -webkit-linear-gradient(
        to right bottom,
        var(--bg-linear) 0%,
        var(--main-color) 100%
    );
    background: -o-linear-gradient(
        to right bottom,
        var(--bg-linear) 0%,
        var(--main-color) 100%
    );
    background: -ms-linear-gradient(
        to right bottom,
        var(--bg-linear) 0%,
        var(--main-color) 100%
    );
    background: linear-gradient(
        to right bottom,
        var(--bg-linear) 0%,
        var(--main-color) 100%
    );

    .login-form {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 80%;
        transform: translate(-50%, -50%);

        .login-tit {
            font-size: 24px;
            font-weight: bold;
            color: var(--white-text-color);
        }

        .el-form {
            margin-top: 40px;

            ::v-deep .el-form-item {
                margin-bottom: 40px;
            }

            ::v-deep input::-webkit-input-placeholder {
                color: var(--white-text-color) !important;
            }
            ::v-deep input::-moz-input-placeholder {
                color: var(--white-text-color) !important;
            }

            ::v-deep input::-ms-input-placeholder {
                color: var(--white-text-color) !important;
            }

            ::v-deep .el-form-item__label {
                color: var(--white-text-color);
            }

            ::v-deep .el-input__inner {
                border: none;
                border-bottom: 1px solid #f2f3f3;
                background: transparent;
                color: var(--white-text-color);
            }

            ::v-deep .el-input__prefix {
                color: var(--white-text-color) !important;
            }

            ::v-deep .el-button {
                color: var(--main-color);

                &:hover {
                    color: var(--main-color);
                }

                &:focus {
                    color: var(--main-color);
                    border-color: #fff;
                }
            }
        }

        .checkbox {
            display: flex;
            height: 40px;
            justify-content: center;
            align-items: center;
            margin-top: 35px;
            color: var(--white-text-color);

            .el-checkbox {
                margin-right: 10px;
            }

            .el-link {
                font-size: 12px;
                color: var(--white-text-color);
            }
        }
    }
}

.login-fail {
    width: 100%;
    text-align: center;

    .fail-tit {
        font-size: 18px;
        font-weight: bold;
        color: #424242;
    }

    .fail-info {
        margin: 15px 0;
        line-height: 24px;
    }
}
</style>